import uniqueHash from "unique-hash"

function hashUrl(url) {
    return uniqueHash(url, { format: "string" })
}

export { hashUrl }